import { Spinner } from "react-bootstrap";
import ProductTableItemLoadingSkeleton from "../../../../../components/LoadingSkeletons/ProductTableItemLoadingSkeleton";
import {
  ListBody,
  ListBodyCell,
  ListBodyItem,
  ListBodyItemAction,
  ListBodyItemNumberformat,
  ListHeader,
  ListHeaderItem,
  ListHeaderItemDropdown,
} from "../../../../../components/_widgets/WidgetsList";
import EmptyListContent from "./EmptyListContent";
import ListFilterHeader from "./ListFilterHeader";

const ListContent = ({
  productList,
  isProductListLoading,
  productsAll,
  totalItems,
  qtLimitItem,
  handleSearch,
  setDeleteProduct,
  setProduct,
  setOpenDrawer,
  setSelectedCategoryChildren,
  subCategories,
  setSelectedImage,
}) => {
  const handleEditProduct = (item) => {
    setProduct({
      ...item,
      productCategory: item.category._id,
      avatarKey: item.avatarKey,
      additional: item.additional.length ? item.additional : [{ title: "", value: 0 }],
    });
    setSelectedImage(item.avatar ? [item.avatar] : []);
    setOpenDrawer(true);
  };

  return (
    <>
      <ListHeader>
        <ListHeaderItem sizeLg={2} title={"Produto"}>
          <ListHeaderItemDropdown>
            <li
              className="dropdown-header d-flex justify-content-end pt-0 pb-1 px-2"
              style={{ borderBottom: "1px solid #D9D9D9" }}
            >
              <div className="input-group input-search">
                <input
                  type="text"
                  style={{ width: "173px" }}
                  className="input-dropdown form-control fz-14 border-0 box-shadow-none text-cl-auroMetal ff-roboto px-1 pb-0"
                  placeholder={"Procure por produto"}
                  onChange={({ target }) => handleSearch(target.value)}
                />

                <span className="input-group-text bg-white border-0">
                  <i className="bi bi-search " style={{ color: "#000000" }}></i>
                </span>
              </div>
            </li>
            <div className="filter-items" style={{ maxHeight: "238px" }}>
              <div onClick={() => handleSearch("")} className="dropdown-item">
                <span>Todos</span>
              </div>
              {productsAll.map((item) => (
                <div key={item._id} onClick={() => handleSearch(item.name)} className="dropdown-item">
                  <span>{item.name}</span>
                </div>
              ))}
            </div>
          </ListHeaderItemDropdown>
        </ListHeaderItem>
        <ListFilterHeader {...{ setSelectedCategoryChildren, subCategories }} title={"Categoria"} />

        <ListHeaderItem sizeLg={2} title={"Quantidade"}></ListHeaderItem>
        <ListHeaderItem sizeLg={2} title={"SKU"}></ListHeaderItem>
        <ListHeaderItem sizeLg={2} title={"Valor"}></ListHeaderItem>
        {/* <ListHeaderItem sizeLg={2} title={"Desconto"}></ListHeaderItem> */}
      </ListHeader>
      <ListBody>
        {isProductListLoading ? (
          <>
            <div className="d-flex justify-content-center py-5 text-cl-auroMetal">
              <Spinner animation="border" role="status" style={{ height: "8rem", width: "8rem", borderWidth: "0.8em" }}>
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            </div>
          </>
        ) : totalItems === 0 ? (
          <EmptyListContent text={"Não existem produtos."} />
        ) : (
          productList?.map((item, index) =>
            index + 1 <= qtLimitItem ? (
              <ListBodyCell
                hover={"cell-onhover c-pointer"}
                key={index}
                className={` cell-onhover ${index % 2 !== 0 ? "bg-cl-cultured" : ""}`}
              >
                <ListBodyItem
                  onClick={() => handleEditProduct(item)}
                  sizeLg={2}
                  description={"Produto"}
                  title={item.name}
                />
                <ListBodyItem
                  onClick={() => handleEditProduct(item)}
                  sizeLg={2}
                  description="Categoria"
                  title={item.category.name}
                />
                <ListBodyItem
                  onClick={() => handleEditProduct(item)}
                  sizeLg={2}
                  description={"Quantidade"}
                  title={item.qty ? item.qty : "N/A"}
                />
                <ListBodyItem
                  onClick={() => handleEditProduct(item)}
                  sizeLg={2}
                  description={"SKU"}
                  title={item.sku ? item.sku : "N/A"}
                />
                <ListBodyItemNumberformat
                  onClick={() => handleEditProduct(item)}
                  sizeLg={2}
                  textColor={"text-cl-forest-green"}
                  description={"Valor"}
                  value={item.price}
                  empty={!item.price ? true : false}
                  avgValue={false}
                />
                {/* <ListBodyItem
                  onClick={() => handleEditProduct(item)}
                  sizeLg={1}
                  description={"Discount"}
                  title={item.discount ? item.discount : "N/A"}
                /> */}
                <ListBodyItemAction sizeLg={1} title={"edit"}>
                  <li
                    onClick={() => {
                      setProduct({
                        ...item,
                        productCategory: item.category._id,
                        avatarKey: item.avatarKey,
                        additional: item.additional || [{ title: "", value: 0 }],
                      });
                      // console.log(item);
                      setSelectedImage(item.avatar ? [item.avatar] : []);
                      setOpenDrawer(true);
                    }}
                  >
                    <span
                      className="dropdown-item fz-14 ff-univanova-regular c-pointer"
                      data-bs-toggle="modal"
                      data-bs-target="#myModalSingle"
                    >
                      Editar/Visualizar
                    </span>
                  </li>
                  <li
                    data-bs-toggle="modal"
                    data-bs-target="#confirmDeleteProduct"
                    onClick={() => setDeleteProduct(item._id)}
                  >
                    <span className="dropdown-item fz-14 ff-univanova-regular text-prop-danger c-pointer  text-cl-red">
                      Excluir
                    </span>
                  </li>
                </ListBodyItemAction>
              </ListBodyCell>
            ) : (
              <></>
            )
          )
        )}
        <button id="btnCallEditProduct" className="d-none" data-bs-toggle="modal" data-bs-target="#myModalSingle">
          Chamar modal edit
        </button>
      </ListBody>
    </>
  );
};

export default ListContent;
